import type {Config} from 'tailwindcss'
import {colors} from '../../packages/shared/colors'

export default {
  content: {
    files: [
      './src/**/*.{js,ts,jsx,tsx}',
      '../../packages/shared/**/*.{js,ts,jsx,tsx}',
      '!../../packages/shared/node_modules/**/*'
    ]
  },
  theme: {
    extend: {
      boxShadow: {
        b: '0 5px 5px -5px rgba(0, 0, 0, 0.1)',
        r: '5px 0px 5px -5px rgba(0, 0, 0, 0.1)'
      },
      width: {
        text: '70rem'
      },
      borderColor: {
        DEFAULT: 'color-mix(in srgb, var(--mantine-color-text), transparent 90%)'
      }
    },
    colors,
    fill: colors,
    fontFamily: {
      sans: ['var(--font-family)'],
      numbers: ['var(--font-family-numbers)'],
      code: ['var(--font-family-code)']
    },
    screens: {
      md: '700px',
      sm: '500px'
    }
  },
  // had to put columns in safelist because its dynamic and would get shaked out otherwise
  safelist: [{pattern: /(columns)-./}],
  plugins: [require('tailwind-scrollbar'), require('@tailwindcss/container-queries')]
} satisfies Config
